import React from 'react'
import { TableCell } from '@material-ui/core'
import { WbProductModel } from '../../../../server/mpsklad_core/Models/WbProductModel'
import { Button } from '../../../shared/ui/button'
import { mpCardRoutes } from '../../../../common/mpCardRoutes'
import { useHistory } from 'react-router-dom'
import { OzonProductModel } from '../../../../server/mpsklad_core/Models/OzonProductModel'
import { YandexMarketProductModel } from '../../../../server/mpsklad_core/Models/YandexMarketProductModel'
import { ProductCardPublicationStatus } from '../../../../server/mpsklad_core/Models/MpCard/ProductCardPublicationStatus'

//TODO: Replace rowType for Generic
interface TableActionsCellProps {
  row: WbProductModel | OzonProductModel | YandexMarketProductModel,
}

const isUpdateDisabled = (status: ProductCardPublicationStatus): boolean => {
  switch (status) {
    case ProductCardPublicationStatus.NotPublished:
    case ProductCardPublicationStatus.Published:
      return false
    case ProductCardPublicationStatus.Processing:
    case ProductCardPublicationStatus.Moderating:
    case ProductCardPublicationStatus.ApiError:
    case ProductCardPublicationStatus.SuccessImport:
      return true
    default: {
      const exhaustiveCheck: never = status
      return exhaustiveCheck
    }
  }
}

export const TableActionsCell = ({row}: TableActionsCellProps) => {
  const history = useHistory()

  const handleClick = () => {
    history.push(mpCardRoutes.import.route({id: String(row.id), productId: String(row.productCardId)}))
  }

  return (
    <TableCell className="table-border">
      <Button onClick={handleClick} width={90}
              disabled={isUpdateDisabled(row.cardPublicationStatus)}>
        Обновить
      </Button>
    </TableCell>
  )
}
